import { useDragAndDropContext } from "./DragAndDropContext";
import { useSelectedDateHasPassed } from "@/Utils/useSelectedDate";

export const useIsShiftDropZoneAvailable = ({
  shiftId,
}: {
  shiftId: number;
}) => {
  const { availableDropZones, drag } = useDragAndDropContext();
  const selectedDateHasPassed = useSelectedDateHasPassed();

  // If the base availability is false, no need to check additional conditions
  if (!availableDropZones.shift) {
    return false;
  }

  // If the selected date has passed, the shift dropzone is not available
  if (selectedDateHasPassed) {
    return false;
  }

  if (drag?.source === "shift-lane") {
    // An activity occurrence cannot be dropped on the shift it is dragged from,
    // nor on a shift it is already assigned to.
    if (drag.shiftId === shiftId) {
      return false;
    }

    if (drag.item.assignees.some((assignee) => assignee.id === shiftId)) {
      return false;
    }
  }

  return availableDropZones.shift;
};
